// Autogenerated file
export const catalogEntityOptionFlagsEnum = {
    None: "None",
    Required: "Required",
    Invisible: "Invisible",
    ShowInMobileApp: "ShowInMobileApp",
    ShowInEmptyMileageBids: "ShowInEmptyMileageBids",
};
export const catalogEntityOptionFlags = [
    { label: "Без свойств", value: "None", intValue: 0 },
    { label: "Обязательное", value: "Required", intValue: 1 },
    { label: "Невидимое", value: "Invisible", intValue: 2 },
    { label: "Показывать в мобильном приложении", value: "ShowInMobileApp", intValue: 4 },
    { label: "Отображать в порожних заявках", value: "ShowInEmptyMileageBids", intValue: 8 },
];
